module.exports = __webpack_public_path__ + "img/code-slash.a318eb85.svg";